export default __webpack_public_path__ + "static/media/6.b44d6f25.svg";